import React, {useEffect, useState} from 'react';
import Logo from './Logo';
import User from './User';
import Help from './Help';
import UserSwitch from './UserSwitch';
import Logout from './Logout';
import Subscription from './Subscription';
import {connect, useDispatch} from 'react-redux';
import {bindActionCreators} from 'redux';
import {openMenu} from '../sidebar/reducer';
import {Link} from 'react-router-dom';
import classnames from 'classnames';
import tutorials from '../../../utils/config/tutorials';
import Joyride from 'react-joyride';
import {hideTourHint} from './reducer';
import partnerUtils from '../../../utils/partnerUtils';
import frontendUtils from '../../../utils/frontendUtils';
import authDao from '../../../dao/authDao';
import './index.css';
import useWindowWidth from '../../hook/useWindowWidth';
import {history} from '../../../utils/redux/store';
import {loadAuth} from '../../auth/reducers';
import {solutionUtils} from '../../../utils/solutionUtils';
import {privilegeUtils} from '../../../utils/privilegeUtils';
import SolutionTypeSwitch from './SolutionTypeSwitch';

export default React.memo(
  connect(
    state => ({
      accountSummary: state.components.auth.accountSummary,
      customersList: state.components.auth.customersList,
      runTourHint: state.components.layout.header.runTourHint,
    }),
    dispatch => bindActionCreators({openMenu, hideTourHint}, dispatch)
  )(function Header({
    openMenu,
    runTourHint,
    hideTourHint,
    accountSummary,
    accountSummary: {customer, isSuperAccount},
  }) {
    const dispatch = useDispatch();
    const width = useWindowWidth();
    const [topbarOn, setTopbarOn] = useState(false);
    const [accountServices, setAccountServices] = useState([]);
    const [filterServices, setFilterServices] = useState([]);
    const isPartnerSite = partnerUtils.isPartnerSite();
    const isMultipleSolutions = solutionUtils.isMultipleSolutions(
      accountSummary
    );
    const isTechnicalSupport = privilegeUtils.isTechnicalSupport(
      accountSummary
    );
    const isSkincare = accountSummary.customer.functionType === 'SKINCARE_PRO';
    const variant = isSkincare ? 'skincare' : 'default';
    const steps = isSkincare
      ? tutorials.skincareStartGuideTour
      : tutorials.startGuideTour;

    useEffect(() => {
      if (isTechnicalSupport) {
        authDao.listTechnicalSupportCustomers().then(r => {
          setAccountServices(r.map(rr => rr.customer));
          setFilterServices(r.map(rr => rr.customer));
        });
      } else {
        authDao.listAccountService().then(r => {
          setAccountServices(r);
          setFilterServices(r);
        });
      }
    }, []);

    const switchCustomer = id => {
      if (id === customer.id) return;
      authDao.switchAccountCustomer(id).then(r => {
        if (r && r.status && r.status === 'success') {
          dispatch(loadAuth());
          history.push('/');
        }
      });
    };

    const searchCustomer = param => {
      setFilterServices(
        accountServices.filter(
          s =>
            s.customerName.toUpperCase().includes(param.toUpperCase()) ||
            s.contactEmail.toUpperCase().includes(param.toUpperCase())
        )
      );
    };

    return (
      <div
        className={classnames({
          'kt-header__topbar--mobile-on': topbarOn,
        })}
      >
        <div className="kt-header kt-grid__item kt-header--fixed">
          <div className="kt-container pf-header">
            <Logo isPartner={isPartnerSite} />
            <div className="kt-header__topbar">
              <SolutionTypeSwitch
                accountServices={accountServices}
                accountSummary={accountSummary}
                isTechnicalSupport={isTechnicalSupport}
                width={width}
                customer={customer}
                searchCustomer={searchCustomer}
                filterServices={filterServices}
                switchCustomer={switchCustomer}
              />
              {!isSuperAccount ? (
                <User isPartner={isPartnerSite} />
              ) : (
                <UserSwitch isPartner={isPartnerSite} />
              )}
              {width > 600 && <Subscription />}
              {!isPartnerSite && <Help />}
              <Logout />
            </div>
          </div>
        </div>
        <div className="kt-header-mobile kt-header-mobile--fixed">
          <div className="kt-header-mobile__logo">
            <Link to={frontendUtils.getPfHomeUrl('smb-partner-logo')}>
              <img
                alt="Logo"
                src={require('../../../assets/images/layout/logo.jpg')}
                width="40%"
              />
            </Link>
          </div>
          <div className="kt-header-mobile__toolbar">
            {!isMultipleSolutions && <Subscription />}
            <button
              className="kt-header-mobile__toolbar-toggler kt-header-mobile__toolbar-toggler--left"
              onClick={() => openMenu()}
            >
              <span />
            </button>
            <button
              className={classnames({
                'kt-header-mobile__toolbar-topbar-toggler': true,
                'kt-header-mobile__toolbar-topbar-toggler--active': topbarOn,
              })}
              onClick={() => setTopbarOn(!topbarOn)}
            >
              <i className="flaticon-more-1" />
            </button>
          </div>
        </div>
        <Joyride
          key={`joyride-${variant}`}
          run={runTourHint}
          steps={steps}
          callback={tutorials.startGuideTourCallback(hideTourHint)}
          styles={{
            options: {
              arrowColor: isSkincare ? '#fff' : '#5067de',
            },
          }}
          tooltipComponent={
            isSkincare
              ? tutorials.customToolTipSkincare
              : tutorials.customToolTip
          }
          continuous
          {...(!isSkincare ? {disableOverlay: true} : {})}
          hideBackButton
        />
      </div>
    );
  })
);
